import { render } from "./EducationInfo.vue?vue&type=template&id=32b47e08"
import script from "./EducationInfo.vue?vue&type=script&lang=js"
export * from "./EducationInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__